import { render } from "./FireNewPassword.vue?vue&type=template&id=82fab47e"
import script from "./FireNewPassword.vue?vue&type=script&lang=ts"
export * from "./FireNewPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script